var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1693 79.1667H41.6693C30.1651 79.1667 20.8359 69.8375 20.8359 58.3334V20.8334",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8359 20.8334H58.3359C69.8401 20.8334 79.1693 30.1625 79.1693 41.6667V79.1667",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2513 31.25L20.8346 20.8334L10.418 31.25",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.668 66.6667L79.168 79.1667L91.668 66.6667",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9514 58.3857C59.8102 59.2446 59.8102 60.6362 58.9514 61.4937C58.0925 62.3526 56.7008 62.3526 55.8434 61.4937C54.9845 60.6349 54.9845 59.2432 55.8434 58.3857C56.7022 57.5269 58.0939 57.5269 58.9514 58.3857",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6891 58.3857C44.548 59.2446 44.548 60.6362 43.6891 61.4937C42.8303 62.3526 41.4386 62.3526 40.5811 61.4937C39.7237 60.6348 39.7223 59.2432 40.5811 58.3857C41.44 57.5282 42.8303 57.5268 43.6891 58.3857",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8734 38.5499H52.4234C53.1893 38.5499 53.8109 39.1715 53.8109 39.9374V53.8124H35.7734",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9359 59.9397H37.1609C36.395 59.9397 35.7734 59.3181 35.7734 58.5522V51.0375",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8125 42.7124H59.8107C60.3781 42.7124 60.8887 43.0579 61.0983 43.5851L63.3266 49.1546C63.457 49.482 63.525 49.8317 63.525 50.1841V58.4369C63.525 59.2028 62.9034 59.8244 62.1375 59.8244H59.597",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2001 59.9452H44.3359",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5227 52.425H57.9727V46.875H62.4127",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7734 38.55H42.7109",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7734 42.7124H39.9359",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1609 46.8749H35.7734",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/Recurring.a0e315c23c08986dd4bbb70f9ad37f5e.svg";
export { ForwardRef as ReactComponent };